import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectsRoutingModule } from './projects-routing.module';
import { ProjectsComponent } from './projects.component';
import { ProjectDetailComponent } from './project-detail/project-detail.component';
import { FormsModule } from '@angular/forms';
import { WindowlistModule } from 'projects/core/src/common/windowlist/windowlist.module';
import { WindowModule } from 'projects/core/src/common/window/window.module';
import { ToolbarmodelModule } from 'projects/core/src/common/toolbarmodel/toolbarmodel.module';
import { PaginationModule } from 'projects/core/src/common/pagination/pagination.module';
import { SelectfieldcustomModule } from 'projects/core/src/common/selectfieldcustom/selectfieldcustom.module';
import { AddressModule } from '../address/address.module';
import { DocumentsModule } from '../documents/documents.module';
import { FilterdateModule } from '../../modules/filterdate/filterdate.module';
import { FilesModule } from '../../modules/files/files.module';
import { FiltercontainerModule } from '../../modules/filtercontainer/filtercontainer.module';
import { WindowlistbuttonsModule } from 'projects/core/src/common/windowlistbuttons/windowlistbuttons.module';
import { Globals } from 'projects/core/src/globals';
import { CustomfieldsModule } from "projects/core/src/common/customfields/customfields.module";
import { AdvancedsearchModule } from "../../modules/advancedsearch/advancedsearch.module";
import { ProjectSettingsComponent } from './settings/settings.component';
import { SettingwindowComponent } from 'projects/core/src/common/settingwindow/settingwindow.component';
import { ImporterModule } from '../../modules/importer/importer.module';
import { ListpluginsComponent } from 'projects/core/src/common/settingwindow/listplugins/listplugins.component';

@NgModule({
  declarations: [
    ProjectsComponent,
    ProjectDetailComponent,
    ProjectSettingsComponent
  ],
  exports:[ProjectsComponent,ProjectSettingsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ProjectsRoutingModule,
    WindowlistModule,
    WindowModule,
    ToolbarmodelModule,
    PaginationModule,
    SelectfieldcustomModule,
   // AddressModule,
    DocumentsModule,
    FilterdateModule,
    FilesModule,
    FiltercontainerModule,
    WindowlistbuttonsModule,
    CustomfieldsModule,
    AdvancedsearchModule,
    SettingwindowComponent,
    ListpluginsComponent,
    ImporterModule
]
})
export class ProjectsModule {

  constructor(){
      Globals.permissions.addPermissionRule("projects","save","Salvataggio");
      Globals.permissions.addPermissionRule("projects","delete","Eliminazione");
  }
  


 }
